import React from 'react';
import { ISVGType } from './SVGType';

const EditSvg = (props: ISVGType) => {
  const { width = 16 , height = 16, color = "#0A0C30" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M16.5 4.20104C16.5006 4.09575 16.4804 3.99138 16.4406 3.89391C16.4008 3.79644 16.3421 3.70779 16.268 3.63304L12.876 0.241046C12.8012 0.166901 12.7126 0.108241 12.6151 0.0684295C12.5176 0.0286179 12.4133 0.00843786 12.308 0.00904657C12.2027 0.00843786 12.0983 0.0286179 12.0009 0.0684295C11.9034 0.108241 11.8147 0.166901 11.74 0.241046L9.476 2.50504L0.732013 11.249C0.657868 11.3238 0.599208 11.4124 0.559396 11.5099C0.519585 11.6074 0.499405 11.7117 0.500013 11.817V15.209C0.500013 15.4212 0.584299 15.6247 0.734328 15.7747C0.884356 15.9247 1.08784 16.009 1.30001 16.009H4.69201C4.80395 16.0151 4.91592 15.9976 5.02066 15.9576C5.1254 15.9177 5.22057 15.8561 5.3 15.777L13.996 7.03303L16.268 4.80904C16.341 4.7315 16.4005 4.64226 16.444 4.54504C16.4517 4.48127 16.4517 4.41681 16.444 4.35304C16.4477 4.3158 16.4477 4.27828 16.444 4.24104L16.5 4.20104ZM4.36401 14.409H2.10001V12.145L10.044 4.20104L12.308 6.46504L4.36401 14.409ZM13.436 5.33704L11.172 3.07304L12.308 1.94504L14.564 4.20104L13.436 5.33704Z"
        fill={color}
      />
    </svg>
  );
};

export default EditSvg;
